import Commands from './commands';

class BaseComparison extends Commands {
    constructor(operator, registry) {
        super(operator, registry);
        this.operator = operator;
    }

    async execute(node, emitter, options) {
        const [param1, param2] = await this.getParameters(node, emitter, options);
        return this.compare(param1, param2);
    }

    async getParameters(node, emitter, options) {
        return Promise.all([
            emitter(node.params[0], options),
            emitter(node.params[1], options)
        ]);
    }

    compare(value1, value2) {
        const [num1, num2] = this.parseNumericValues(value1, value2);

        if (this.areNumeric(num1, num2)) {
            return this.compareNumeric(num1, num2);
        }

        return this.compareValues(value1, value2);
    }

    parseNumericValues(value1, value2) {
        return [parseFloat(value1), parseFloat(value2)];
    }

    areNumeric(...values) {
        return values.every(value => !isNaN(value));
    }

    compareNumeric(num1, num2) {
        return this.compareValues(num1, num2);
    }

    compareValues(value1, value2) {
        throw new Error('compareValues must be implemented by child class');
    }
}

export default BaseComparison;
